export const COMMON_CONSTANTS = {
  DATE_FORMAT_FOR_DOWNLOAD_FILE_NAME: 'YYYY-MM-DD_HHmmss'
}
